import axios from 'axios'
let _baseUrl = 'https://www.youlimei.com'
// if(localStorage.getItem('YLMlang') === 'en') {
//     _baseUrl = 'https://www.en.youlimei.com'
// }

const service = axios.create({
    // baseURL: 'https://apifoxmock.com/m1/5243160-4910772-default', // url = base url + request url
    baseURL: _baseUrl, // url = base url + request url
    // baseURL: '/apiYLM', // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 35000 // request timeout
})
axios.defaults.withCredentials = true

// request interceptor
service.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json;charset=utf-8'
        // config.headers['TENANT-ID'] = '1'
        // if (!config.headers.Authorization) {
        // config.headers["Authorization"] = ""
        // config.headers["Authorization"] = "Bearer " + sessionStorage.getItem('token')
        // config.headers["TENANT-ID"] = 1
        // }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    res => {
        const status = Number(res.status) || 200
        if (status != 200) {
            this.$message({
                message: res.data.message || '错误',
                duration: 3 * 1000
            })
            return Promise.reject(new Error(res.data.message || '错误'))
        }
        return res.data
    },
    error => {
        switch (error.response.status) {
            case 400:
                this.$message({
                    // message: error.response.data,
                    message: 'test',
                    duration: 1500,
                })
                break
            case 401:
                // router.replace("/login");
                this.$message({
                    message: '跳转登陆页面',
                    duration: 1500
                })
                break
            case 405:
                this.$message({
                    message: 'http请求方式有误',
                    duration: 1500,
                })
                break
            case 404:
            case 500:
                this.$message({
                    message: '服务器出了点小差，请稍后再试',
                    duration: 1500,
                })
                break
            case 501:
                this.$message({
                    message: '服务器不支持当前请求所需要的某个功能',
                    duration: 1500,
                })
                break
        }
        return Promise.reject(error.response.data.msg)
    }
)

export default service